import React from 'react';
import './header.css';
import logo from '../assets/logo.svg';

function Header() {
  return (
    <header className="app-header">
      <div className="header-content">
        <img src={logo} alt="Gomoku" className="app-logo" />
        <h1>Gomoku</h1>
        <div className="header-subtitle">Five in a Row</div>
      </div>
    </header>
  );
}

export default Header;